import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {
    FriendsListActionType,
    FriendsListAction,
    LoadFriendsListAction,
    LoadFriendsListFailedAction,
    LoadFriendsListSucceededAction,
    SearchFriendsListAction,
    SearchFriendsListSucceededAction,
    SearchFriendsListFailedAction,
    SendFriendRequestAction,
    SendFriendRequestSucceededAction,
    SendFriendRequestFailedAction,
} from './friendList.actions';
import {
    FriendsListService
} from '../../firebase/friendsList.service';
import { SopoLoadingService } from 'src/app/shared/services/sopo-loading/sopo-loading.service';


@Injectable()
export class FriendsListEffects {

    
    loadFriendsList$: Observable < FriendsListAction > = createEffect(() => this.actions$
        .pipe(
            ofType(FriendsListActionType.LOAD_FRIENDS_LIST),
            switchMap((action: LoadFriendsListAction) => {
                this.loadingCtrl.present('general');
                return from(this.friendsListService.loadFriendsList()
                    .then(friends => {
                        return new LoadFriendsListSucceededAction(friends);
                    })
                    .catch(error => {
                        return new LoadFriendsListFailedAction({
                            'error': error
                        });
                    })
                    .finally(() =>{
                        this.loadingCtrl.dismiss('general');
                    })
                );
            })
        ));
        
    
    searchFriendsList$: Observable < FriendsListAction > = createEffect(() => this.actions$
        .pipe(
            ofType(FriendsListActionType.SEARCH_FRIENDS_LIST),
            switchMap((action: SearchFriendsListAction) => {
                return from(this.friendsListService.searchFriendsList(action.query)
                    .then(friends => {
                        return new SearchFriendsListSucceededAction(friends);
                    })
                    .catch(error => {
                        return new SearchFriendsListFailedAction({
                            'error': error
                        });
                    })
                );
            })
        ));
        
    
    sendFriendRequest$: Observable < FriendsListAction > = createEffect(() => this.actions$
        .pipe(
            ofType(FriendsListActionType.SEND_FRIEND_REQUEST),
            switchMap((action: SendFriendRequestAction) => {
                return from(this.friendsListService.sendFriendRequest(action.userID)
                    .then(() => {
                        this.toastr.success('Sent friend request successfully.', '', {
                            positionClass: 'toast-bottom-center'      
                        });
                        return new SendFriendRequestSucceededAction(action.userID);
                    })
                    .catch(error => {
                        this.toastr.error('Send friend request failed.', '', {
                            positionClass: 'toast-bottom-center'      
                        });
                        return new SendFriendRequestFailedAction({
                            'error': error
                        });
                    })
                );
            })
        ));

    constructor(private friendsListService: FriendsListService,
        private actions$: Actions,
        private loadingCtrl: SopoLoadingService,
        private toastr: ToastrService) {
        
    }
}
